import { Col, Form, Row } from "react-bootstrap";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import { validateFile } from "components/Api/common";

const StepForm3 = () => {
    const { organizeSafari, organizeSafariErrors, sharedSafariDispatch, } = useSharedSafariContext();

    const updateField = (name, value) => {
        if (name === "shared_safari_image") {
            const imageUrl = URL.createObjectURL(value);
            const error = validateFile(value);

            if (error) {
                sharedSafariDispatch({
                    type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
                    payload: { [name]: error[name] || "Invalid file" },
                });
                sharedSafariDispatch({
                    type: "UPDATE_ORGANIZE_SHARE_SAFARI",
                    payload: {
                        [name]: null,
                        safariPhotoUrl: ''
                    },
                });
            } else {
                sharedSafariDispatch({
                    type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
                    payload: { [name]: "" },
                });
                sharedSafariDispatch({
                    type: "UPDATE_ORGANIZE_SHARE_SAFARI",
                    payload: {
                        [name]: value,
                        safariPhotoUrl: imageUrl
                    },
                });
            }
        } else {
            sharedSafariDispatch({
                type: "UPDATE_ORGANIZE_SHARE_SAFARI",
                payload:{[name]: value },
            });
            sharedSafariDispatch({
                type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
                payload: { [name]: "" },
            });
        }
    };



    return (
        <Row className="pt-3">
            {/* Current Display Image */}
            <Col xs={12} md={6} className="mb-2">
                <Form.Label className="Modal_label">Current Display Image</Form.Label>
                {organizeSafari?.safariPhotoUrl ? (
                    <img
                        src={organizeSafari?.safariPhotoUrl}
                        alt="Current Display"
                        width="100%"
                        height="100px"
                        style={{ objectFit: "contain" }}
                    />
                ) : (
                    <div
                        style={{
                            height: "100px",
                            background: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #ccc",
                        }}
                    >
                        No image selected
                    </div>
                )}
            </Col>

            {/* Select Picture */}
            <Col xs={12} md={6} className="mb-2">
                <Form.Label htmlFor="sharedSafariImage" className="Modal_label">
                    Select Picture
                </Form.Label>
                <Form.Group controlId="sharedSafariImage" className="mb-3">
                    <Form.Control
                        type="file"
                        name="shared_safari_image"
                        onChange={(e) => updateField("shared_safari_image", e.target.files[0])}
                        isInvalid={!!organizeSafariErrors?.shared_safari_image}
                        accept=".jpg,.jpeg,.png"
                    />
                    <Form.Control.Feedback type="invalid" style={{ minHeight: "1.25rem" }}>
                        {organizeSafariErrors?.shared_safari_image || "Please select a valid image"}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
            {/* Safari Plan */}
            <Col xs={12}>
                <Form.Label htmlFor="safariPlan" className="Modal_label">
                    Safari Plan <span className="necessary">*</span>
                </Form.Label>
                <Form.Group controlId="safariPlan" className="mb-3">
                    <Form.Control
                        as="textarea"
                        rows={6}
                        placeholder="Enter Plan Details"
                        value={organizeSafari?.safari_plan}
                        isInvalid={!!organizeSafariErrors?.safari_plan}
                        onChange={(e) => updateField("safari_plan", e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid" style={{ minHeight: "1.25rem" }}>
                        {organizeSafariErrors?.safari_plan || "Plan is required"}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>
    );
};

export default StepForm3;
